import { useEffect, useRef, useState } from "react";
import { useAuth } from "../context/Auth";
import useUpdateTaxRate from "./update-tax-rate.data";
import { CallToast } from "../PriceCalculator/modals/CustomToast";
import { Button } from "react-bootstrap";
import { WhiteLoader } from "../Theme/APILoaders";
import { getAPIData } from "../../Utils/commonApi";

const AddEditTaxRateModal = ({
  show,
  hideModal,
  taxRateData = {
    ObjectId: 0,
    TaxCode: "",
    TaxName: "",
    TaxRate: "",
  },
  updateTaxList = () => {},
  deleteTaxRate = () => {},
  showDelete = false
}) => {
  const { authTokens } = useAuth();
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [data, setData] = useState({});
  const addEditTaxRateModalRef = useRef();
  const { isLoading: isTaxRateUpdating, updateTaxRate } = useUpdateTaxRate();
  useEffect(() => {
    console.log(taxRateData);
    setData(taxRateData);
  }, [taxRateData]);

  function handleClickOutside(event) {
    if (
      addEditTaxRateModalRef.current &&
      !addEditTaxRateModalRef.current.contains(event.target)
    ) {
      hideModal();
    }
  }
  useEffect(() => {
    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [show]);

  return (
    <div className="add-edit-tax-rate-modal" ref={addEditTaxRateModalRef}>
      {/* header */}
      <div className="p-0 modal-header">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="f-500 ml-2 f-12 f-grey f-500">
            {data.ObjectId === 0 ? "Add" : "Edit"} a tax code
          </div>
          <img
            alt=""
            src="/images/user-detail-close.svg"
            className="mr-1 pointer"
            onClick={hideModal}
          />
        </div>
      </div>

      {/* Body */}
      <div className="p-1 d-flex align-items-center" style={{ gap: '8px' }}>
        <div className="d-flex align-items-center search-supplier-input highlight-input bg-grey radius-4 mb-1 p-1">
          <input
            type="text"
            className=" w-100 border-none bg-transparent"
            value={data?.TaxName}
            placeholder="Name"
            onChange={(e) => {
              let value = e.target.value;
              setData((prev) => ({ ...prev, TaxName: value }));
            }}
            autoFocus
          />
        </div>

        <div className="d-flex align-items-center justify-content-between" style={{ gap: '8px' }}>
          <div className="f-black" style={{ whiteSpace: 'nowrap' }}>Tax Rate</div>
          <div className="d-flex align-items-center search-supplier-input highlight-input radius-4 p-1">
            <input
              type="text"
              className=" w-100 border-none bg-transparent"
              placeholder="0.00"
              value={data?.TaxRate}
              onChange={(e) => {
                let value = e.target.value
                  .toString()
                  .replaceAll(/[^0-9%]/g, "");
                setData((prev) => ({ ...prev, TaxRate: value }));
              }}
              autoFocus
            />
            <span className="ml-1">%</span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="d-flex align-items-center justify-content-between border-top" style={{ padding: '4px 4px 0 4px' }}>
        {showDelete && (
          <div
            className="d-flex align-items-center f-500 f-grey pointer"
            onClick={() => {
              setDeleting(true);
              deleteTaxRate(data?.ObjectId).then((response) => {
                setDeleting(false);
                if (response?.Success) {
                  updateTaxList({ deletedId: data?.ObjectId });
                  CallToast("Deleted Successfully", false, false, "v2style");
                  hideModal();
                } else {
                  CallToast("Something went wrong", false, false, "v2style");
                }
              });
            }}
          >
            {data.ObjectId !== 0 && (
              <>
                <img
                  alt=""
                  className="mx-2"
                  src="/images/actioncenter/delete.svg"
                />
                {deleting ? "Deleting.." : "Delete"}
              </>
            )}
          </div>
        )}
        <div className="d-flex w-100 align-items-center justify-content-end">
          <Button className="hg-cancel-btn mr-2 f-12" onClick={hideModal}>
            Cancel
          </Button>
          <Button
            className="hg-blue-btn f-12"
            disabled={saving || !data?.TaxName || !data?.TaxRate}
            onClick={async () => {
              setSaving(true);
              await updateTaxRate({
                ...data,
                TaxRate: data?.TaxRate?.toString().replaceAll("%", ""),
              }).then((response) => {
                setSaving(false);
                if (response?.Success) {
                  updateTaxList({ created: data.ObjectId || response?.EntityId });
                  CallToast("Updated Successfully", false, false, "v2style");
                  hideModal();
                } else {
                  CallToast("Something went wrong", false, false, "v2style");
                }
              });
            }}
          >
            {saving ? (
              <>
                <WhiteLoader width={13} />
                Saving..
              </>
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddEditTaxRateModal;

export async function  deleteTaxRate(_taxRateId){
  const authTokens = JSON.parse(localStorage.getItem("tokens"));
 return new Promise((resolve, reject) => {
   getAPIData(`${772}`, authTokens, {
     optionEnum1: _taxRateId, 
   })
     .then((response) => {
       CallToast("Deleted Successfully", false, false, "v2style");
       resolve(response);
     })
     .catch((err) => {
       console.log(err);
       reject(err);
     });
 });
}
